import type {
    DripSequenceStartTriggersForStageset_stageset_editableProcessTemplate_nutshellMarketingStartTriggers as StartTrigger,
    DripSequenceStartTriggersForStageset_stageset as Stageset,
} from 'nutshell-graphql-types';

export function translateDripSequenceStartTriggersData(
    stageIds: string[],
    stageset?: Stageset | null
): {
    [id: string]: StartTrigger | null | undefined[];
} {
    let startTriggers: {
        [id: string]: StartTrigger | null | undefined[];
    } = {};

    startTriggers = stageIds.reduce((acc, stageId) => {
        acc[stageId] = [];

        return acc;
    }, startTriggers);

    // Not sure what we should do if theres no stages here. I guess
    // just not show the card at all.
    const firstStageId = stageIds.length > 0 ? stageIds[0] : undefined;

    if (!firstStageId || !stageset) {
        return startTriggers;
    }

    const startTriggerArray = stageset.editableProcessTemplate.nutshellMarketingStartTriggers;
    startTriggerArray.sort((a: StartTrigger, b: StartTrigger) => {
        // Sort our start triggers, so that the first triggers
        // in the array are for lead created, then all stage
        // entered triggers are sorted so that the earlier the
        // start stage, the higher they are in the list. This
        // ensures that we get a reverse pyrmaid, with the
        // largest cards at the top, and smaller cards at the
        // bottom.
        if (a.type === 'LEAD_CREATED') {
            return -1;
        }

        if (b.type === 'LEAD_CREATED') {
            return 1;
        }

        const aStartTriggerStageId = getStartTriggerStageId(a);
        const bStartTriggerStageId = getStartTriggerStageId(b);

        const aStageIndex = aStartTriggerStageId
            ? stageIds.findIndex((stageId) => aStartTriggerStageId === stageId)
            : -1;
        const bStageIndex = bStartTriggerStageId
            ? stageIds.findIndex((stageId) => bStartTriggerStageId === stageId)
            : -1;

        return aStageIndex - bStageIndex;
    });

    startTriggers = stageset.editableProcessTemplate.nutshellMarketingStartTriggers.reduce(
        (acc, startTrigger: StartTrigger) => {
            let stageId;
            if (startTrigger.type === 'LEAD_CREATED') {
                // The lead was created, so we'll just show this on
                // the first stage
                stageId = firstStageId;
            } else {
                // The automation is lead enters stage, so lets show
                // this trigger on that stage
                stageId = getStartTriggerStageId(startTrigger);
            }

            if (stageId && acc[stageId]) {
                // @ts-expect-error
                acc[stageId].push(startTrigger);

                // This sorts the array of start triggers for the stage
                // by campaign name, pushing 'null' to the beginning of the array
                // @ts-expect-error
                if (acc[stageId].length > 1) {
                    // @ts-expect-error
                    acc[stageId].sort((a, b) =>
                        !b || (a && b && a.campaign.name > b.campaign.name) ? 1 : -1
                    );
                }

                let index = stageIds.findIndex((findStageId) => stageId === findStageId) + 1;

                while (index < stageIds.length) {
                    // @ts-expect-error
                    acc[stageIds[index]].push(null);
                    index += 1;
                }
            }

            return acc;
        },
        startTriggers
    );

    return startTriggers;
}

function getStartTriggerStageId(startTrigger: StartTrigger): string | null | undefined {
    // Check we have conditions
    return startTrigger.conditions.length > 0 &&
        // @ts-expect-error
        startTrigger.conditions[0].config.__typename === 'ConditionConfigEntityFilter' &&
        // Check the conditions config is a
        // relationship type
        // @ts-expect-error
        startTrigger.conditions[0].config.filter.__typename ===
            'EntityFilterFieldConfigRelationship' &&
        // Check we have relationship data
        // @ts-expect-error
        startTrigger.conditions[0].config.filter.relationshipData.length > 0
        ? // Get the relationship data (the stage
          // id)
          // @ts-expect-error
          startTrigger.conditions[0].config.filter.relationshipData[0]
        : undefined;
}
